import React from 'react';

const Sidebar = () => {
  const aiFeatures = [
    { icon: '👤', name: 'AI Rename', description: 'Smart file naming' },
    { icon: '🗃️', name: 'AI Subtitle Translate', description: 'Auto translate subtitles' },
    { icon: '📁', name: 'Auto Folder Sort', description: 'Organize by content type' },
    { icon: '☁️', name: 'Cloud Sync', description: 'Backup to cloud storage' }
  ];

  const quickActions = [
    { icon: '📥', name: 'Open Downloads', action: 'open-downloads' },
    { icon: '📊', name: 'History', action: 'history' },
    { icon: '⚙️', name: 'Settings', action: 'settings' }
  ];

  const handleAction = (action) => {
    switch (action) {
      case 'open-downloads':
        // Open downloads folder
        break;
      case 'history':
        // Show download history
        break;
      case 'settings':
        // Open settings
        break;
      default:
        break;
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-section">
        <h3 className="section-title">🧠 AI Features</h3>
        <div className="feature-list">
          {aiFeatures.map((feature, index) => (
            <div key={index} className="feature-item">
              <span className="feature-icon">{feature.icon}</span>
              <div className="feature-content">
                <span className="feature-name">{feature.name}</span>
                <span className="feature-desc">{feature.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">⚡ Quick Actions</h3>
        <div className="action-list">
          {quickActions.map((action, index) => (
            <button 
              key={index} 
              className="action-item"
              onClick={() => handleAction(action.action)}
            >
              <span className="action-icon">{action.icon}</span>
              <span className="action-name">{action.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
